import { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { authApi } from '../lib/api';
import { useTheme, Icons } from '../lib/design-system';
import Spinner from '../components/ui/Spinner';

export default function VerifyEmail() {
  const { theme } = useTheme();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setErrorMsg('Kein Bestätigungs-Token gefunden.');
      return;
    }

    authApi
      .verifyEmail(token)
      .then(() => setStatus('success'))
      .catch((err: any) => {
        setStatus('error');
        setErrorMsg(err.response?.data?.error || 'Der Link ist ungültig oder abgelaufen.');
      });
  }, [token]);

  return (
    <div
      className="min-h-screen flex items-center justify-center p-4"
      style={{
        background: `linear-gradient(135deg, ${theme.primary} 0%, ${theme.secondary} 50%, ${theme.accent} 100%)`,
      }}
    >
      <div
        className="w-full max-w-sm p-8 rounded-3xl shadow-2xl text-center"
        style={{ backgroundColor: theme.surface }}
      >
        <div
          className="w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-6"
          style={{ backgroundColor: theme.primaryLight }}
        >
          {status === 'loading' && <Spinner size="md" />}
          {status === 'success' && <Icons.Check size={32} weight="bold" style={{ color: theme.primary }} />}
          {status === 'error' && <Icons.Warning size={32} weight="bold" style={{ color: theme.error }} />}
        </div>

        {status === 'loading' && (
          <>
            <h1 className="text-xl font-bold mb-2" style={{ color: theme.text }}>
              Email wird bestätigt…
            </h1>
          </>
        )}

        {status === 'success' && (
          <>
            <h1 className="text-xl font-bold mb-2" style={{ color: theme.text }}>
              Email bestätigt!
            </h1>
            <p className="text-sm mb-6" style={{ color: theme.textMuted }}>
              Deine Email-Adresse wurde erfolgreich bestätigt.
            </p>
            <Link to="/trainer" className="btn-primary inline-block px-6 py-3 text-sm">
              Zum Dashboard
            </Link>
          </>
        )}

        {status === 'error' && (
          <>
            <h1 className="text-xl font-bold mb-2" style={{ color: theme.text }}>
              Bestätigung fehlgeschlagen
            </h1>
            <p className="text-sm mb-6" style={{ color: theme.textMuted }}>
              {errorMsg}
            </p>
            <Link to="/login" className="text-sm underline" style={{ color: theme.primary }}>
              Zurück zum Login
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
